import {router} from "@inertiajs/vue3";
import FormButtons from "@/pages/components/form-buttons.vue";
import AssetFields from "@/mixins/shared/assetFields";

export default {
	mixins: [AssetFields],
	components: {FormButtons},

	data() {
		return {
			formRoute: '',
			redirectRoute: '',
			loading: false,
			stayOnPage: true
		}
	},

	methods: {
		submit() {
			this.loading = true;
			let form = {};
			if (this.form) {
				form = this.form;
			} else {
				form = this.$refs.form.form;
			}

			return $.ajax({
				url: this.formRoute,
				method: this.getFormMethod(),
				contentType: 'application/json',
				processData: false,
				data: JSON.stringify(this.stripAssetFields(form.data())),
				success: this.onSuccess.bind(this, form),
				error: this.onError.bind(this, form),
			}).always(() => {
				this.loading = false;
				this.afterSubmit(form);
			});
		},

		async onSuccess(form, response) {
			let failedAssets = await this.syncAssetFields(form, response.data?.id);

			form.reset('password', 'password_confirmation');
			form.defaults();
			form.reset();

			await this.$nextTick();

			if (failedAssets.length) {
				// Bij mislukte uploads blijven we op het edit-scherm, ook bij opslaan en sluiten
				Helpers.Message.error(this.getFailedAssetsMessage(failedAssets));
				this.afterSuccess(form, response)
				return;
			}

			if (!this.stayOnPage) {
				router.get(this.redirectRoute, {
					'success': 'De wijzigingen zijn opgeslagen'
				});
				return;
			}
			if (response.message) {
				Helpers.Message.success(response.message);
			} else {
				Helpers.Message.success('De wijzigingen zijn opgeslagen');
			}

			this.afterSuccess(form, response)
		},

		afterSuccess(form, response) {

		},

		afterSubmit(form) {
			$(document).trigger('customsubmit');
		},

		onError(form, response) {
			Helpers.Form.handleErrors(form, response);
		},

		getSuccessMessage() {
			return 'De wijzigingen zijn opgeslagen';
		},

		getFormMethod() {
			return 'PUT'
		}
	}
}
